<footer class="site-footer">
  <div class="container">
    <div class="text-center" data-aos="fade-up" data-aos-duration="1100">
      <img src="assets/img/logo-a.png" />
      <h5 class="font-weight-bold mt-4 my-3 text-uppercase">
        have a question in your mind?
      </h5>
    </div>
    <form class="footer-form">
      <div class="row">
        <div
          class="col-xl-8 mx-auto"
          [formGroup]="contactForm"
          (ngSubmit)="submitContact(formDirective)"
          #formDirective="ngForm"
        >
          <div class="row">
            <div class="col-md-6">
              
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Your Name"
                  formControlName="name"
                  [ngClass]="{
                    'is-invalid':
                      (submitted || (f.name.touched && !f.name.valid)) &&
                      f.name.errors
                  }"
                />
                <div
                  *ngIf="(submitted || f.name.touched) && f.name.errors"
                  class="invalid-feedback"
                >
                  <!-- Show only one error message -->
                  <div *ngIf="f.name.errors.required">
                    Full Name is required
                  </div>
                  <div
                    *ngIf="!f.name.errors.required && f.name.errors.whitespace"
                  >
                    Name cannot be just whitespace
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <input
                  type="email"
                  class="form-control"
                  placeholder="Email Address"
                  formControlName="email"
                  [ngClass]="{
                    'is-invalid':
                      (submitted || (f.email.touched && !f.email.valid)) &&
                      f.email.errors
                  }"
                />
                <div
                  *ngIf="(submitted || f.email.touched) && f.email.errors"
                  class="invalid-feedback"
                >
                  <!-- Show only one error message -->
                  <div *ngIf="f.email.errors.required">Email is required</div>
                  <div
                    *ngIf="
                      !f.email.errors.required &&
                      (f.email.errors.email || f.email.errors.pattern)
                    "
                  >
                    Please enter a proper email address (e.g. user@domain.com)
                  </div>
                </div>
              </div>
             
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Phone Number"
                  appPhoneMask
                  minlength="14"
                  maxlength="14"
                  formControlName="mobileNumber"
                  (keypress)="cmnfunction.keyPress($event)"
                  [ngClass]="{
                    'is-invalid':
                      (submitted ||
                        (f.mobileNumber.touched && !f.mobileNumber.valid)) &&
                      f.mobileNumber.errors
                  }"
                />
                <div
                  *ngIf="
                    (submitted || f.mobileNumber.touched) &&
                    f.mobileNumber.errors
                  "
                  class="invalid-feedback"
                >
                  <div *ngIf="f.mobileNumber.errors.required">
                    Phone Number is required
                  </div>
                  <div *ngIf="f.mobileNumber.errors.minlength">
                    Enter Minimum 10 digit Phone number
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <select
                  class="form-control"
                  formControlName="type"
                  [ngClass]="{
                    'is-invalid':
                      (submitted || (f.type.touched && !f.type.valid)) &&
                      f.type.errors
                  }"
                >
                  <option value="" disabled>Type of Inquiry</option>
                  <ng-container *ngFor="let ti of inquryTypes">
                    <option value="{{ ti.type }}">{{ ti.type }}</option>
                  </ng-container>
                </select>
                <div
                  *ngIf="(submitted || f.type.touched) && f.type.errors"
                  class="invalid-feedback"
                >
                  <div *ngIf="f.type.errors.required">Type is required</div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <textarea
                  rows="4"
                  class="form-control"
                  placeholder="Message"
                  style="resize: none"
                  formControlName="message"
                  [ngClass]="{
                    'is-invalid':
                      (submitted || (f.message.touched && !f.message.valid)) &&
                      f.message.errors
                  }"
                >
                </textarea>
                
                <button
                  type="submit"
                  (click)="submitContact(formDirective)"
                  class="btn btn-primary"
                  [disabled]="isLoadingData"
                >
                  <i class="fa fa-paper-plane" aria-hidden="true">
                    <span *ngIf="isLoadingData">
                      <span
                        class="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                    </span>
                  </i>
                </button>
                <div
                  *ngIf="(submitted || f.message.touched) && f.message.errors"
                  class="invalid-feedback"
                >
                  <!-- Show only one error message -->
                  <div *ngIf="f.message.errors.required">
                    Message is required
                  </div>
                  <div
                    *ngIf="
                      !f.message.errors.required && f.message.errors.whitespace
                    "
                  >
                    Message cannot be just whitespace
                  </div>
                </div>
              </div>

            
            </div>
            <div class="col-md-12">
               <div class="text-center">
                  <div class="links">
                      <p>
                          <a routerLink="/privacy-policy"  target="_blank">Privacy Policy</a> | 
                          <a routerLink="/terms-and-conditions" target="_blank">Terms & Conditions</a> | 
                          <a routerLink="/delete-user-request">Delete User Request</a>
                      </p>
                  </div>
              </div>
              <div
                class="social-footer-icon text-center my-4"
                data-aos="zoom-in"
                data-aos-duration="1100"
              >
                <a class="mr-3 mr-lg-4" href="{{ socialLinks?.facebook }}"
                  ><img src="assets/img/footer-fb.png"
                /></a>
                <a class="mr-3 mr-lg-4" href="{{ socialLinks?.twitter }}"
                  ><img src="assets/img/footer-tw.png"
                /></a>
                <a class="mr-3 mr-lg-4" href="{{ socialLinks?.instagram }}"
                  ><img src="assets/img/footer-insta.png"
                /></a>
                <a class="mr-3 mr-lg-4" href="{{ socialLinks?.linkedin }}"
                  ><img src="assets/img/footer-linkedin.png"
                /></a>
                <a class="" href="{{ socialLinks?.youtube }}"
                  ><img src="assets/img/footer-youtube.png"
                /></a>
              </div>
              <div class="text-center">
                <p>
                  © Copyright {{ todayDate | date : "yyyy" }} by Wooffer. All
                  Rights Reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</footer>
